import {INavigationPage} from "./iNavigationPage";

export class NavigationController implements ng.IController {
    private _allowSideNavToChange: boolean = true;

    static $inject: string[] = ['$mdSidenav', 'LogoutService', '$state', '$mdMedia', '$window'];

    constructor(private _$mdSidenav: ng.material.ISidenavService,
        private _logoutService: Authentication.LogoutService,
        private _$state: ng.ui.IStateService,
        public $mdMedia: ng.material.IMedia,
        private _$window: ng.IWindowService) {
    }

    $onInit() { }

    toggleSidenav(): void {
        if (this._allowSideNavToChange) {
            this._allowSideNavToChange = false;
            this._$mdSidenav('nav').toggle().then(() => {
                this._allowSideNavToChange = true;
            });
        }
    }

    navigate(state: string): void {
        if (state === '') return;
        this._$state.go(state);
        this.toggleSidenav();
    }

    isCurrentState(state: string): boolean {
        return state === this._$state.current.name;
    }

    isParentState(state: string): boolean {
        return this._$state.current.data ? this._$state.current.data.navParent === state : false;
    }

    getPageTitle(): string {
        return this._$state.current.data ? this._$state.current.data.title : '';
    }

    goBack(): void {
        if (this._$state.current.data) {
            this._$state.go(this._$state.current.data.navParent);
        } else {
            this._$window.history.back();
        }
    }

    close(): void {
        this._$window.history.back();
    }

    isPageActive(state: string): boolean {
        return this.isCurrentState(state) || this.isParentState(state);
    }

    isParentActive(children: Array<INavigationPage>): boolean {

        let oneOfItsChildrenHasState = _.filter(children,
                c => this._$state.current.name.indexOf(c.stateName) > -1).length > 0;

        let oneOfItsChildrensParentsHasState = angular.isDefined(this._$state.current.data) && angular.isDefined(this._$state.current.data.navParent) &&
            _.filter(children, c => this._$state.current.data.navParent.indexOf(c.stateName) > -1).length > 0;

        let hasChildren = angular.isDefined(children);

        return hasChildren && (oneOfItsChildrenHasState || oneOfItsChildrensParentsHasState);
    }

}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/navigation/navigationController.ts
 **/